<script setup lang="ts">
</script>

<template>
  <div class="container container--animation">
    <h1 class="title">
      404
    </h1>
    <p class="text">
      Нет такой страницы
    </p>
  </div>
</template>

<style scoped>
.title,
.text {
  text-align: center;
}

</style>
